import React from "react";

const CreateTagSectionForm = ({
  sectionTitle,
  setSectionTitle,
  sectionDesc,
  setSectionDesc,
  sectionMode,
  setSectionMode,
  onSubmit,
}) => {
  return (
    <div className="pb-card">
      <h2>Create Tag Section</h2>
      <form onSubmit={onSubmit}>
        <label className="pb-label">Title</label>
        <input
          className="pb-input"
          value={sectionTitle}
          onChange={(e) => setSectionTitle(e.target.value)}
          placeholder="e.g. Reactor Instruments"
          required
        />

        <label className="pb-label">Mode</label>
        <select
          className="pb-select"
          value={sectionMode}
          onChange={(e) => setSectionMode(e.target.value)}
        >
          <option value="analog">Analog</option>
          <option value="digital">Digital</option>
          <option value="io">IO (Analog Input)</option>
        </select>

        <label className="pb-label">Description (optional)</label>
        <textarea
          className="pb-textarea"
          value={sectionDesc}
          onChange={(e) => setSectionDesc(e.target.value)}
          placeholder="Optional"
        />

        <button className="pb-button" type="submit">
          Create Section
        </button>
      </form>
    </div>
  );
};

export default CreateTagSectionForm;